/** 
 * 基于axios的请求方法
 */

import axios from 'axios'
import config from '../../../../config/index.js'


axios.defaults.baseURL = config.baseUrl;

const http = {
    post(url, params, finalFunc, headers) {
        return new Promise((resolve, reject) => {
            axios.post(url, params, {headers}).then((res) => {
                finalFunc && finalFunc()
                resolve(res.data)
            }).catch((err) => {
                finalFunc && finalFunc()
                reject(err)
            })
        })
    },
    get(url, params, finalFunc, headers) {
        return new Promise((resolve, reject) => {
            let config = {
                params
            }
            if (headers) {
                config.headers = headers
            }
            axios.get(url, config).then((res) => {
                finalFunc && finalFunc()
                resolve(res.data)
            }).catch((err) => {
                finalFunc && finalFunc()
                reject(err)
            })
        })
    }
}

export default http